import { getViewportForBounds, type Padding, type Viewport } from '@xyflow/system';

import { MAX_ZOOM } from '../constants';
import { type FlowRect } from './viewportVisibility';

/** Programmatic fit can zoom below user-facing MIN_ZOOM (0.01). */
export const FIT_VIEW_PROGRAMMATIC_MIN_ZOOM = 0.001;

export type ComputeFitViewportInput = {
  bounds: FlowRect;
  width: number;
  height: number;
  padding: Padding;
  minZoom?: number;
  maxZoom?: number;
};

export const computeFitViewport = ({
  bounds,
  width,
  height,
  padding,
  minZoom = FIT_VIEW_PROGRAMMATIC_MIN_ZOOM,
  maxZoom = MAX_ZOOM,
}: ComputeFitViewportInput): Viewport | undefined => {
  if (width <= 0 || height <= 0 || bounds.width <= 0 || bounds.height <= 0) {
    return undefined;
  }

  return getViewportForBounds(bounds, width, height, minZoom, maxZoom, padding);
};
